export default __webpack_public_path__ + "static/media/mp-logo.fc5110c6.jpg";